<template>
  <el-container>

    <el-container>
      <el-aside class="left_menu_container"
                style="z-index:1">
        <leftMenu type="setting" />
      </el-aside>
      <el-main class="work_container  invoiceContainer">
        <el-row>
          <el-col :span="22"
                  class="t_l"
                  :offset="1">
            <div style="background-color: white;margin-left: 20px;height: 100vh;">
              <el-row style="clear:both;height:40px"></el-row>
              <div>
                <span class="pageTitle">发票管理</span>
              </div>
              <div>

                <el-radio-group v-model="invoiceType"
                                class="t_l"
                                style="margin-top: 30px;">
                  <el-radio-button label="开具发票"></el-radio-button>
                  <el-radio-button label="发票记录"></el-radio-button>
                  <el-radio-button label="发票信息管理"></el-radio-button>
                </el-radio-group>

              </div>
              <div style="clear: both;height: 10px;"></div>

              <div class="invoiceDesc">
                发票说明：<br />
                1、用户可申请电子版普通发票，如需纸质形式，可将电子发票打印（电子发票与纸质发票具有同等法律效力）；<br />
                2、发票开具金额为用户实际支付金额，不包括红包、优惠券支付的金额；<br />
                3、用户提交开票申请后，5个工作日内受理并开具电子发票；<br />
                <tenplate v-if="isOpen">
                  4、请仔细核对发票抬头、金额、税号、地址及其他相关信息，因为信息填写错误导致的发票开具出错，将不能重开；<br />
                  5、发票开具后，除发生开票有误情况，其他情况不予置换；<br />
                  6、2023年11月之前生成的订单暂时无法由用户自行开具发票，如有开票需求请联系客服。如需其他帮助，也请咨询客服。
                </tenplate>
                <el-link :underline="false"
                         style="width:100%"
                         @click="isOpen=!isOpen">
                  <div :class="'open_close_'+ isOpen  "></div>
                </el-link>

              </div>
              <div style="clear: both;height: 10px;"></div>
              <template v-if="invoiceType==='开具发票'">

                <div>

                  <template v-if="curStep==='select'">
                    <div class="pageTitle">选择开票订单</div>
                    <div style="clear: both;height: 10px;"></div>
                    <el-tabs v-model="tabName">
                      <el-tab-pane label="可开票订单"
                                   name="enable">

                        <div class=" infinite-list"
                             v-infinite-scroll="getEnableOrders"
                             :infinite-scroll-delay=500
                             :infinite-scroll-distance=100
                             :infinite-scroll-immediate=true
                             :infinite-scroll-disabled='enableFinish'
                             style="overflow:auto;max-height: calc(100vh - 530px);">
                          <el-table :data="enableList"
                                    highlight-current-row
                                    style="width: 100%"
                                    empty-text="   "
                                    @selection-change="selectOrder">
                            <el-table-column type="selection"
                                             width="55"> </el-table-column>
                            <el-table-column property="no"
                                             label="订单号"
                                             width="350">
                            </el-table-column>
                            <el-table-column property="payTime"
                                             label="支付时间">
                            </el-table-column>
                            <el-table-column property="packageContext"
                                             label="购买内容">
                            </el-table-column>

                            <el-table-column label="支付金额">
                              <template slot-scope="scope">
                                {{ scope.row.salesPrice }}元
                              </template>
                            </el-table-column>

                            <el-table-column property="payType"
                                             label="支付途径">
                            </el-table-column>

                          </el-table>
                          <template v-if="enableFinish">
                            <div class="noData">
                              <i class="iconfont">&#xe629;</i>
                              数据加载完毕!
                            </div>
                          </template>
                          <template v-else>
                            <div class="noData">
                              <span class="icon_run">
                                <i class="iconfont">&#xe67b;</i>
                              </span>数据加载中...
                            </div>
                          </template>
                        </div>
                        <div style="clear: both;height: 20px;"></div>
                        <div style="text-align: right;font-size: 20px;font-weight: 500;"
                             v-if="selectAmount">
                          <span style="color:#2A82E4"> {{selectedOrders.length}}</span>笔订单，共<span style="color:#2A82E4"> {{selectAmount}}</span>元&nbsp;&nbsp;&nbsp;&nbsp;
                          <el-button type="primary"
                                     style="font-size: 20px;"
                                     @click="toConfirm">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;下一步&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</el-button>
                        </div>

                      </el-tab-pane>
                      <el-tab-pane label="其他订单"
                                   name="other">
                        <div v-if="tabName === 'other'"
                             class="infinite-list"
                             v-infinite-scroll="getOtherOrders"
                             :infinite-scroll-delay=500
                             :infinite-scroll-distance=100
                             :infinite-scroll-immediate=true
                             :infinite-scroll-disabled='otherFinish'
                             style="overflow:auto;height: calc(100vh - 370px);">
                          <el-table :data="otherList"
                                    empty-text="   "
                                    highlight-current-row
                                    style="width: 100%">

                            <el-table-column property="no"
                                             label="订单号"
                                             width="350">
                            </el-table-column>
                            <el-table-column property="payTime"
                                             label="支付时间">
                            </el-table-column>
                            <el-table-column property="packageContext"
                                             label="购买内容">
                            </el-table-column>
                            <el-table-column label="支付金额">
                              <template slot-scope="scope">
                                {{ scope.row.salesPrice }}元
                              </template>
                            </el-table-column>
                            <el-table-column property="isInvoice"
                                             label="订单状态">
                            </el-table-column>
                            <el-table-column property="payType"
                                             label="支付途径">
                            </el-table-column>

                          </el-table>
                          <template v-if="otherFinish">
                            <div class="noData">
                              <i class="iconfont">&#xe629;</i>
                              数据加载完毕!
                            </div>
                          </template>
                          <template v-else>
                            <div class="noData">
                              <span class="icon_run">
                                <i class="iconfont">&#xe67b;</i>
                              </span>数据加载中...
                            </div>
                          </template>
                        </div>
                      </el-tab-pane>
                    </el-tabs>
                  </template>
                  <template v-if="curStep==='confirm'">
                    <el-row>
                      <el-col :span="24">
                        <div class="pageTitle">确认发票信息 &nbsp; <el-link type="primary"
                                   @click="openChangeInvoiceInfoDialog "
                                   style="font-size: 16px;">修改</el-link></div>
                        <div style="clear: both;height: 20px;"></div>
                        <div>
                          <div class="invoice_row">
                            <div class="invoice_lable">发票类型：</div>
                            <div class="invoice_value"> 普通发票（电子发票）</div>
                          </div>
                          <div class="invoice_row">
                            <div class="invoice_lable">发票内容：</div>
                            <div class="invoice_value"> 服务费</div>
                          </div>
                          <div class="invoice_row">
                            <div class="invoice_lable">发票抬头：</div>
                            <div class="invoice_value"> {{ invoiceInfo.invoiceFilled }}</div>
                          </div>
                          <div class="invoice_row">
                            <div class="invoice_lable">公司税号：</div>
                            <div class="invoice_value"> {{ invoiceInfo.companyTaxNumber }}</div>
                          </div>
                          <div class="invoice_row">
                            <div class="invoice_lable">银行账号（选填）：</div>
                            <div class="invoice_value"> {{ invoiceInfo.bankAccount }}</div>
                          </div>
                          <div class="invoice_row">
                            <div class="invoice_lable">开户行（选填）：</div>
                            <div class="invoice_value"> {{ invoiceInfo.depositBank }}</div>
                          </div>
                          <div class="invoice_row">
                            <div class="invoice_lable">注册地址（选填）：</div>
                            <div class="invoice_value"> {{ invoiceInfo.registeredAddress }}</div>
                          </div>
                          <div class="invoice_row">
                            <div class="invoice_lable">企业电话（选填）：</div>
                            <div class="invoice_value"> {{ invoiceInfo.contactPhone }}</div>
                          </div>

                        </div>
                        <div style="clear: both;height: 20px;"></div>
                        <div class="pageTitle">接收方式</div>
                        <div style="clear: both;height: 20px;"></div>
                        <el-form ref="emailRef"
                                 label-position="left"
                                 label-width="100px"
                                 :model="emailForm"
                                 :rules="emailRules">
                          <el-col :span="9">
                            <el-form-item label="电子邮箱："
                                          prop="email">
                              <el-input v-model="emailForm.email"
                                        placeholder="请输入电子邮箱"></el-input>
                            </el-form-item>
                          </el-col>

                        </el-form>

                      </el-col>
                    </el-row>
                    <div style="text-align: right;font-size: 20px;font-weight: 500;"
                         v-if="selectAmount">
                      <span style="color:#2A82E4"> {{selectedOrders.length}}</span>笔订单，共<span style="color:#2A82E4"> {{selectAmount}}</span>元&nbsp;&nbsp;&nbsp;&nbsp;
                      <el-button style="font-size: 20px;"
                                 @click="curStep='select'">上一步</el-button>
                      <el-button type="primary"
                                 style="font-size: 20px;"
                                 @click="showConfirmDailog">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;确认&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</el-button>
                    </div>

                  </template>

                </div>
              </template>
              <template v-if="invoiceType==='发票记录'">
                <div class=" infinite-list"
                     v-infinite-scroll="getInvoiceList"
                     :infinite-scroll-delay=500
                     :infinite-scroll-distance=100
                     :infinite-scroll-immediate=true
                     :infinite-scroll-disabled='invoiceListFinish'
                     style="overflow:auto;max-height: calc(100vh - 370px);">
                  <el-table :data="invoiceList"
                            empty-text="   "
                            highlight-current-row
                            style="width: 100%">

                    <el-table-column property="invoiceType"
                                     label="发票类型">
                    </el-table-column>
                    <el-table-column property="invoiceContent"
                                     label="发票内容">
                    </el-table-column>
                    <el-table-column label="发票金额">
                      <template slot-scope="scope">
                        {{ scope.row.invoiceValue }}元
                      </template>
                    </el-table-column>
                    <el-table-column property="addTime"
                                     label="开具时间">
                    </el-table-column>
                    <el-table-column property="status"
                                     label="发票状态">
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button type="text"
                                   @click="showInvoiceDetail(scope.row.id)">查看详情</el-button>

                        <el-button type="text"
                                   :disabled="scope.row.status!=='已开具'"
                                   @click="toChangeMail(scope.row.id)">重开发票</el-button>
                      </template>
                    </el-table-column>

                  </el-table>
                  <template v-if="invoiceListFinish">
                    <div class="noData">
                      <i class="iconfont">&#xe629;</i>
                      数据加载完毕!
                    </div>
                  </template>
                  <template v-else>
                    <div class="noData">
                      <span class="icon_run">
                        <i class="iconfont">&#xe67b;</i>
                      </span>数据加载中...
                    </div>
                  </template>
                </div>
              </template>
              <template v-if="invoiceType==='发票信息管理'">
                <div v-if="!isEdit && invoiceInfo.invoiceFilled">

                  <div class="invoice_row">
                    <div class="invoice_lable">发票类型：</div>
                    <div class="invoice_value"> 普通发票（电子发票）</div>
                  </div>
                  <div class="invoice_row">
                    <div class="invoice_lable">发票内容：</div>
                    <div class="invoice_value"> 服务费</div>
                  </div>
                  <div class="invoice_row">
                    <div class="invoice_lable">发票抬头：</div>
                    <div class="invoice_value"> {{ invoiceInfo.invoiceFilled }}</div>
                  </div>
                  <div class="invoice_row">
                    <div class="invoice_lable">公司税号：</div>
                    <div class="invoice_value"> {{ invoiceInfo.companyTaxNumber }}</div>
                  </div>
                  <div class="invoice_row">
                    <div class="invoice_lable">银行账号（选填）：</div>
                    <div class="invoice_value"> {{ invoiceInfo.bankAccount }}</div>
                  </div>
                  <div class="invoice_row">
                    <div class="invoice_lable">开户行（选填）：</div>
                    <div class="invoice_value"> {{ invoiceInfo.depositBank }}</div>
                  </div>
                  <div class="invoice_row">
                    <div class="invoice_lable">注册地址（选填）：</div>
                    <div class="invoice_value"> {{ invoiceInfo.registeredAddress }}</div>
                  </div>
                  <div class="invoice_row">
                    <div class="invoice_lable">企业电话（选填）：</div>
                    <div class="invoice_value"> {{ invoiceInfo.contactPhone }}</div>
                  </div>
                  <div style="clear:both;height:20px"></div>
                  <div style="text-align: center;">

                    <el-button type="primary"
                               @click="isEdit=true">&nbsp;&nbsp;&nbsp;&nbsp;修改&nbsp;&nbsp;&nbsp;&nbsp;</el-button>
                  </div>
                </div>
                <div v-else>
                  <div>
                    <el-row>
                      <el-col :span="10">
                        <el-form label-position="left"
                                 label-width="160px"
                                 ref="invoiceForm1"
                                 :rules="invoiceInfoRules"
                                 :model="invoiceInfoForm">
                          <el-form-item label="发票类型">
                            普通发票（电子发票）
                          </el-form-item>
                          <el-form-item label="发票内容">
                            服务费
                          </el-form-item>
                          <el-form-item label="发票抬头"
                                        prop="invoiceFilled">
                            <el-input v-model="invoiceInfoForm.invoiceFilled"
                                      placeholder="请输入发票抬头"></el-input>
                          </el-form-item>
                          <el-form-item label="公司税号"
                                        prop="companyTaxNumber">
                            <el-input v-model="invoiceInfoForm.companyTaxNumber"
                                      placeholder="请输入公司税号"></el-input>
                          </el-form-item>
                          <el-form-item label="银行账号（选填）">
                            <el-input v-model="invoiceInfoForm.bankAccount"
                                      placeholder="请输入内容（选填）"></el-input>
                          </el-form-item>
                          <el-form-item label="开户行（选填）">
                            <el-input v-model="invoiceInfoForm.depositBank"
                                      placeholder="请输入内容（选填）"></el-input>
                          </el-form-item>
                          <el-form-item label="注册地址（选填）">
                            <el-input v-model="invoiceInfoForm.registeredAddress"
                                      placeholder="请输入内容（选填）"></el-input>
                          </el-form-item>
                          <el-form-item label="企业电话（选填）">
                            <el-input v-model="invoiceInfoForm.contactPhone"
                                      placeholder="请输入内容（选填）"></el-input>
                          </el-form-item>
                          <div style="clear:both;height:20px"></div>

                        </el-form>
                      </el-col>
                    </el-row>
                    <div style="text-align:center">
                      <el-button type="primary"
                                 @click="saveInvoiceInfo('invoiceForm1')">&nbsp;&nbsp;&nbsp;&nbsp;保存&nbsp;&nbsp;&nbsp;&nbsp;</el-button>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </el-col>
        </el-row>
      </el-main>
    </el-container>

    <!---弹窗相关----->

    <el-dialog custom-class="xy_dialog  invoiceDialog t_l"
               title="开具电子发票"
               :visible.sync="confirmDialogVisible"
               width="600px">
      <div class="invoice_row">
        <div class="invoice_lable">发票类型：</div>
        <div class="invoice_value"> 普通发票（电子发票）</div>
      </div>

      <div class="invoice_row">
        <div class="invoice_lable">发票抬头：</div>
        <div class="invoice_value"> {{ invoiceInfo.invoiceFilled }}</div>
      </div>
      <div class="invoice_row">
        <div class="invoice_lable">公司税号：</div>
        <div class="invoice_value"> {{ invoiceInfo.companyTaxNumber }}</div>
      </div>
      <div class="invoice_row">
        <div class="invoice_lable">接收方式：</div>
        <div class="invoice_value"> {{ emailForm.email }}</div>
      </div>
      <div style="color: #999999;font-size: 12px;"> 请确认电子邮箱准确无误，电子发票将在系统开具后发送至您留下的邮箱，请注意查收。</div>
      <span slot="footer"
            class="dialog-footer">

        <el-button type="primary"
                   @click="confirm">确定提交</el-button>
      </span>
    </el-dialog>
    <el-dialog custom-class="xy_dialog  invoiceDialog t_l"
               title="开具电子发票"
               :visible.sync="okDialogVisible"
               width="450px">
      您的发票正在开具，请注意查收。如果需要重开发票，<br>可前往【发票记录】进行操作。
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="okDialogVisible=false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog custom-class="xy_dialog  invoiceDialog t_l"
               title="查看发票详情信息"
               :visible.sync="invoiceDetailDialogVisible"
               width="500">

      <div class="invoice_row">
        <div class="invoice_lable">发票类型</div>
        <div class="invoice_value"> {{ invoiceDetail.invoiceType }}</div>
      </div>
      <div class="invoice_row">
        <div class="invoice_lable">发票抬头</div>
        <div class="invoice_value"> {{ invoiceDetail.invoiceFilled }}</div>
      </div>
      <div class="invoice_row">
        <div class="invoice_lable">公司税号</div>
        <div class="invoice_value"> {{ invoiceDetail.companyTaxNumber }}</div>
      </div>
      <div class="invoice_row">
        <div class="invoice_lable">发票金额</div>
        <div class="invoice_value"> {{ invoiceDetail.invoiceValue }}</div>
      </div>
      <div class="invoice_row">
        <div class="invoice_lable">申请时间</div>
        <div class="invoice_value"> {{ invoiceDetail.addTime }}</div>
      </div>
      <div class="invoice_row">
        <div class="invoice_lable">接收邮箱</div>
        <div class="invoice_value"> {{ invoiceDetail.email }}</div>
      </div>

      <div style="clear: both;height: 10px;"></div>
      <div style="font-weight: bolder;">本发票包含{{ invoiceDetail.orderList&& invoiceDetail.orderList.length }}笔订单</div>
      <el-table :data="invoiceDetail.orderList"
                style="width: 100%">
        <el-table-column prop="no"
                         label="订单号">
        </el-table-column>
        <el-table-column prop="payTime"
                         label="支付时间"
                         width="180">
        </el-table-column>
        <el-table-column prop="packageContext"
                         label="购买内容">
        </el-table-column>
        <el-table-column prop="salesPrice"
                         label="支付金额">
        </el-table-column>
      </el-table>
      <span slot="footer"
            class="dialog-footer">

        <el-button type="primary"
                   @click="invoiceDetailDialogVisible=false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog custom-class="xy_dialog   invoiceDialog t_l"
               title="重开电子发票"
               :visible.sync="changeMailDialogVisible"
               width="500px">
      <div class="invoice_row">
        <div class="invoice_lable">发票类型</div>
        <div class="invoice_value"> {{ invoiceDetail.invoiceType }}</div>
      </div>
      <div class="invoice_row">
        <div class="invoice_lable">发票抬头</div>
        <div class="invoice_value"> {{ invoiceDetail.invoiceFilled }}</div>
      </div>
      <div class="invoice_row">
        <div class="invoice_lable">公司税号</div>
        <div class="invoice_value"> {{ invoiceDetail.companyTaxNumber }}</div>
      </div>

      <el-form ref="emailRef2"
               label-position="left"
               label-width="100px"
               :model="emailForm"
               :rules="emailRules">
        <el-form-item label="电子邮箱："
                      prop="email">
          <el-input v-model="emailForm.email"
                    placeholder="请输入电子邮箱"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">

        <el-button type="primary"
                   @click="changeMail">确认提交</el-button>
      </span>
    </el-dialog>

    <el-dialog custom-class="xy_dialog  invoiceDialog t_l"
               title="修改发票信息"
               :visible.sync="changeInvoiceDialogVisible"
               width="600px">
      <el-row>
        <el-col :span="24">
          <el-form label-position="left"
                   :rules="invoiceInfoRules"
                   ref="invoiceForm2"
                   label-width="160px"
                   :model="invoiceInfoForm">
            <el-form-item label="发票类型">
              普通发票（电子发票）
            </el-form-item>
            <el-form-item label="发票内容">
              服务费
            </el-form-item>
            <el-form-item label="发票抬头"
                          prop="invoiceFilled">
              <el-input v-model="invoiceInfoForm.invoiceFilled"></el-input>
            </el-form-item>
            <el-form-item label="公司税号"
                          prop="companyTaxNumber">
              <el-input v-model="invoiceInfoForm.companyTaxNumber"></el-input>
            </el-form-item>
            <el-form-item label="银行账号（选填）">
              <el-input v-model="invoiceInfoForm.bankAccount"></el-input>
            </el-form-item>
            <el-form-item label="开户行（选填）">
              <el-input v-model="invoiceInfoForm.depositBank"></el-input>
            </el-form-item>
            <el-form-item label="注册地址（选填）">
              <el-input v-model="invoiceInfoForm.registeredAddress"></el-input>
            </el-form-item>
            <el-form-item label="企业电话（选填）">
              <el-input v-model="invoiceInfoForm.contactPhone"></el-input>
            </el-form-item>
            <div style="clear:both;height:20px"></div>
          </el-form>
        </el-col>
      </el-row>

      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="saveInvoiceInfo('invoiceForm2')">&nbsp;&nbsp;&nbsp;&nbsp;保存&nbsp;&nbsp;&nbsp;&nbsp;</el-button>
      </span>
    </el-dialog>
    <price v-if="priceListDialogVisible"
           :show=priceListDialogVisible />

  </el-container>
</template>

<script>
import Qrcode from 'vue-qr'
import price from './price'
import leftMenu from '../components/left_menu.vue'
export default {

  data: function () {
    let isEmail = (rule, value, callback) => {
      let reg = /^([a-zA-Z\d][\w-]{2,})@(\w{2,})\.([a-z]{2,})(\.[a-z]{2,})?$/
      if (!reg.test(value)) {
        callback(new Error('请输入正确的邮箱'));
      } else {
        callback();
      }
    };
    return {
      isOpen: false,
      isEdit: false,
      keyword: '',
      userInfo: '',
      menuIndex: '0',
      infiniteFinish: false,
      lastId: -1,
      orders: [],
      total: 1,
      tabName: 'enable',
      priceListDialogVisible: 0,
      invoiceType: '开具发票',
      enableList: [],
      enableFinish: false,
      enableLastId: -1,
      otherList: [],
      otherFinish: false,
      otherLastId: -1,
      selectedOrders: [],
      selectAmount: 0,
      curStep: 'select',
      invoiceInfo: {
        invoiceFilled: '',
        companyTaxNumber: ''
      },
      invoiceInfoForm: {
        invoiceFilled: '',
        companyTaxNumber: ''
      },
      invoiceInfoRules: {
        invoiceFilled: [
          { required: true, message: '发票抬头不能为空', trigger: 'blur' }
        ],
        companyTaxNumber: [
          { required: true, message: '公司税号不能为空', trigger: 'blur' }
        ]
      },
      confirmDialogVisible: false,
      okDialogVisible: false,

      invoiceList: [],
      lastInvoiceId: -1,
      invoiceListFinish: false,
      invoiceDetailDialogVisible: false,
      invoiceDetail: {},
      changeMailDialogVisible: false,
      changeInvoiceDialogVisible: false,
      emailForm: { email: '' },
      emailRules: {
        email: [
          { required: true, message: '请填写邮箱', trigger: 'blur' },
          {
            validator: isEmail, trigger: 'blur'
          }
        ]
      }

    }
  },
  filters: {
    genderFilter: function (val) {
      if (val === 'MALE') {
        return '男'
      } else if (val === 'FEMALE') {
        return '女'
      } else {
        return '未知'
      }
    },
    numFilter (value) {
      let realVal = parseFloat(value).toFixed(2)
      return realVal
    }
  },
  methods: {
    openChangeInvoiceInfoDialog () {
      this.invoiceInfoForm = JSON.parse(JSON.stringify(this.invoiceInfo))
      this.changeInvoiceDialogVisible = true
    },

    changeMail () {
      this.$refs['emailRef2'].validate((valid) => {
        if (valid) {
          this.axios.get(`/webApi/v3/invoice/reSendInvoice?invoiceId=${this.invoiceDetail.id}&email=${this.emailForm.email}`).then(resp => {
            this.changeMailDialogVisible = false
            this.getInvoiceInfo()
            this.$message({
              message: '发票重新发送成功',
              type: 'success'
            });
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    toChangeMail (id) {
      this.changeMailDialogVisible = true
      this.axios.get(`/webApi/v3/invoice/invoiceDetail?invoiceId=${id}`).then(resp => {
        this.invoiceDetail = resp.data
      })
    },
    showInvoiceDetail (id) {
      this.invoiceDetailDialogVisible = true
      this.axios.get(`/webApi/v3/invoice/invoiceDetail?invoiceId=${id}`).then(resp => {
        this.invoiceDetail = resp.data
      })
    },
    saveInvoiceInfo (refname) {
      this.$refs[refname].validate((valid) => {
        if (valid) {
          this.axios.post(`/webApi/v3/invoice/addInvoiceInfo`, this.invoiceInfoForm).then(resp => {
            this.isEdit = false;
            this.changeInvoiceDialogVisible = false
            this.$message({
              message: '发票信息保存成功',
              type: 'success'
            });
            this.getInvoiceInfo()
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    showConfirmDailog () {
      this.$refs['emailRef'].validate((valid) => {
        if (valid) {
          this.confirmDialogVisible = true
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    confirm () {
      this.$refs['emailRef'].validate((valid) => {
        if (valid) {
          let orderIds = this.selectedOrders.map((o) => o['id']).join(',')
          this.confirmDialogVisible = false
          this.axios.post(`/webApi/v3/invoice/toInvoice`, { 'mail': this.emailForm.email, 'orderIds': orderIds }).then(resp => {
            this.okDialogVisible = true
            this.curStep = 'select'
            this.enableLastId = -1
            this.enableList = []
            this.enableFinish = false
            this.getEnableOrders()
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    toConfirm () {
      if (this.invoiceInfo && this.invoiceInfo.companyTaxNumber) {
        this.curStep = 'confirm'
      } else {
        this.invoiceType = '发票信息管理'
      }
    },
    selectOrder (orders) {
      this.selectedOrders = orders
      this.selectAmount = 0
      this.selectedOrders.forEach(f => {
        this.selectAmount += parseFloat(f.salesPrice)
      })
    },
    getEnableOrders () {
      let _this = this
      this.axios.get(`/webApi/v3/invoice/orderList?invoiceStatus=1&orderId=${this.enableLastId}`).then(resp => {
        _this.enableList = _this.enableList.concat(resp.data)
        if (resp.data.length === 0) {
          _this.enableFinish = true
        }
        if (_this.enableList.length > 0) {
          _this.enableLastId = _this.enableList.slice(-1)[0].id
        }
      })
    },
    getInvoiceList () {
      let _this = this
      this.axios.get(`/webApi/v3/invoice/invoiceList?invoiceId=${this.lastInvoiceId}`).then(resp => {
        _this.invoiceList = _this.invoiceList.concat(resp.data)
        if (resp.data.length === 0) {
          _this.invoiceListFinish = true
        }
        if (_this.invoiceList.length > 0) {
          _this.lastInvoiceId = _this.invoiceList.slice(-1)[0].id
        }
      })
    },

    getOtherOrders () {
      let _this = this
      this.axios.get(`/webApi/v3/invoice/orderList?invoiceStatus=0&orderId=${this.otherLastId} `).then(resp => {
        _this.otherList = _this.otherList.concat(resp.data)

        if (resp.data.length === 0) {
          _this.otherFinish = true
        }
        if (_this.otherList.length > 0) {
          _this.otherLastId = _this.otherList.slice(-1)[0].id
        }
      })
    },
    getInvoiceInfo () {
      this.axios.get('/webApi/v3/invoice/getInvoiceInfo').then(resp => {
        this.invoiceInfo = resp.data || {}
        this.invoiceInfoForm = JSON.parse(JSON.stringify(this.invoiceInfo))
      })
    }
  },
  components: {
    qrcode: Qrcode,
    price,
    leftMenu
  },
  mounted () {
    this.getInvoiceInfo()
  },
  watch: {

  }
}
</script>
<style lang="less">
@import '../assets/css/index.less';
.invoiceContainer {
}
.invoiceDialog {
  background-color: white !important;
  border-radius: 10px !important;
  padding-left: 20px;
  .el-dialog__header {
    height: auto !important;
    .el-dialog__title {
      display: inline-block !important;
      padding: 20px;
    }
  }
  .el-dialog__body {
    padding-top: 10px;
  }
  .el-dialog__footer {
    text-align: center;
    padding-bottom: 30px;
  }
  .el-form-item {
    margin-bottom: 10px;
  }
  .el-input {
    display: block;
  }
  .el-form-item__content {
    float: left !important;
    position: relative;
  }
}

.priceDialog {
  .el-dialog__header {
    padding: 0px !important;
  }
}
</style>

<style lang="less" scoped>
.open_close_false {
  background-image: url('../assets/imgs/down.png');
  width: 20px;
  height: 20px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.open_close_true {
  background-image: url('../assets/imgs/up.png');
  width: 20px;
  height: 20px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.invoiceDesc {
  font-size: 12px;
  border-radius: 8px;
  background: rgba(248, 248, 248, 1);
  padding: 15px;
  padding-bottom: 5px;
  line-height: 20px;
  margin-top: 10px;
  margin-bottom: 15px;
}
.invoice_row {
  margin-bottom: 15px;
  .invoice_lable {
    display: inline-block;
    color: #999999;
  }
  .invoice_value {
    display: inline-block;
    margin-left: 10px;
    color: #333333;
    min-width: 300px;
  }
}
.work_container {
  padding: 0px;
  min-width: 930px;

  p {
    text-align: left;
  }

  h6 {
    color: black;
    text-align: left;
  }

  .vipTitle {
    color: black;
    font-size: 1.2em;
    margin: 10px 5px;
  }

  .vipTip {
    font-size: 0.9em;
  }

  .vipTag {
    background-color: #eaf3ff;
    border-radius: 0;
    color: #333333;
    font-size: 1.2em;
    padding: 0px 30px;
    line-height: 60px;
    height: 60px;
    float: left;
    margin-right: 50px;
  }

  .vipBuyBtn {
    width: 135px;
    margin-top: 14px;
  }

  .title_lable {
    width: 100%;
    // text-align-last: justify;
    // text-align: justify;
    // text-justify: distribute-all-lines;
    // width: 86px;
    display: inline-block;
    text-align: left;
  }

  .account_info_item {
    height: 70px;
    width: 700px;
    line-height: 50px;
    text-align: left;
  }
}

.price_package_container {
  padding: 0px 10px !important;
  height: auto !important;
  overflow: hidden;
  width: 125px !important;
  margin-right: 25px;
}

.price_package_container .el-radio__input {
  display: none;
}

.payTypeBtn {
  width: 150px;
  height: 50px !important;

  .el-radio__input {
    top: -9px;
  }
}
</style>



// WEBPACK FOOTER //
// src/app/invoice.vue